// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  requestId: __t.u64().primaryKey().name("request_id"),
  civ: __t.string(),
  settlementId: __t.u64().name("settlement_id"),
  asked: __t.i32(),
  sent: __t.i32(),
  at: __t.timestamp(),
});
